export class PendingsOrdersImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  typeId: number = 0;
  purchaseOrderNumber: string = "";
  dateOrder: Date = new Date;
  orderStateId: number = 0;
  costCenterCode: number = 0;
  advertiser: string = "";
  observation: string = "";
  remissionObservation: string = "";
  articleCode: number = 0;
  initialQuantity: number = 0;
  quantityRemission: number = 0;
  unitValue: number = 0;
  compromiseDate: Date = new Date;

  constructor(
    counter: number,
    companyId: number,
    branchId: number,
    consecutive: number,
    typeId: number,
    purchaseOrderNumber: string,
    dateOrder: Date,
    orderStateId: number,
    costCenterCode: number,
    advertiser: string,
    observation: string,
    remissionObservation: string,
    articleCode: number,
    initialQuantity: number,
    quantityRemission: number,
    unitValue: number,
    compromiseDate: Date
  ) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.consecutive = consecutive;
    this.typeId = typeId;
    this.purchaseOrderNumber = purchaseOrderNumber;
    this.dateOrder = dateOrder;
    this.orderStateId = orderStateId;
    this.costCenterCode = costCenterCode;
    this.advertiser = advertiser;
    this.observation = observation;
    this.remissionObservation = remissionObservation;
    this.articleCode = articleCode;
    this.initialQuantity = initialQuantity;
    this.quantityRemission = quantityRemission;
    this.unitValue = unitValue;
    this.compromiseDate = compromiseDate;
  }
}